/* Barely There Litter: refresh pre-order properties from live Shopify Liquid. */
(() => {
  'use strict';
  const root = (document.currentScript.dataset.root || '/').replace(/\/?$/, '/');
  const originalFetch = window.fetch.bind(window);
  let queue = Promise.resolve();
  let resuming = false;
  let checkingOut = false;
  const enqueue = task => {
    const result = queue.catch(() => {}).then(task);
    queue = result.catch(() => {});
    return result;
  };
  const normalise = value => Array.isArray(value) ? Object.fromEntries(value) : {...(value || {})};
  function propertiesFor(item, country) {
    const properties = normalise(item.properties);
    const hadPreorder = properties['Sale type'] === 'Pre-order' || properties['Pre-order estimate'] || properties['_Pre-order batch'] || properties['_BTL preorder state'];
    if (!item.active && !hadPreorder) return properties;
    if (properties['Sale type'] === 'Pre-order') delete properties['Sale type'];
    delete properties['Pre-order estimate'];
    delete properties['_Pre-order batch'];
    if (item.active) {
      properties['Sale type'] = 'Pre-order';
      properties['Pre-order estimate'] = item.estimate;
      properties['_Pre-order batch'] = item.batch;
    }
    properties['_BTL preorder state'] = item.active ? 'preorder' : 'in_stock';
    properties['_BTL preorder market'] = country;
    properties['_BTL preorder rule'] = '2';
    return properties;
  }
  const equal = (a,b) => {
    const keys = Object.keys(a);
    return keys.length === Object.keys(b).length && keys.every(key => a[key] === b[key]);
  };
  async function readState(path = root + 'cart') {
    const url = new URL(path, location.origin);
    url.searchParams.set('section_id', 'btl-preorder-state');
    url.searchParams.set('_btl', Date.now());
    const response = await originalFetch(url.href, {cache:'no-store', credentials:'same-origin'});
    if (!response.ok) throw new Error('Delivery details could not be refreshed.');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const element = html.querySelector('[data-btl-preorder-state]');
    const state = element && JSON.parse(element.textContent);
    if (!state || state.version !== 2 || !Array.isArray(state.items)) throw new Error('Delivery details are unavailable.');
    return state;
  }
  async function synchronise() {
    let changed = false;
    let state = await readState();
    const limit = state.items.length * 2 + 5;
    for (let attempt = 0; attempt < limit; attempt++) {
      const item = state.items.find(item => !equal(normalise(item.properties), propertiesFor(item, state.country)));
      if (!item) return {changed, state};
      const response = await originalFetch(root + 'cart/change.js', {
        method:'POST', credentials:'same-origin',
        headers:{'Content-Type':'application/json', Accept:'application/json'},
        body:JSON.stringify({id:item.key, quantity:item.quantity, properties:propertiesFor(item, state.country)})
      });
      if (!response.ok) throw new Error('Your cart changed. Please try again.');
      changed = true;
      state = await readState();
    }
    throw new Error('Your cart changed. Please try again.');
  }
  function refreshCart() {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles:true}));
  }
  function showError() {
    let notice = document.getElementById('btl-delivery-check-error');
    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'btl-delivery-check-error';
      notice.setAttribute('role','alert');
      notice.style.cssText = 'position:fixed;bottom:20px;left:50%;transform:translateX(-50%);z-index:2147483647;max-width:90%;padding:16px 24px;background:#fff;border:1px solid #888;color:#222;box-shadow:0 2px 12px #0002;';
      document.body.append(notice);
    }
    notice.textContent = 'We couldn’t refresh your delivery details. Please try checkout again.';
  }
  window.fetch = function(input, init) {
    const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.origin);
    const method = (init?.method || input?.method || 'GET').toUpperCase();
    if (url.origin === location.origin && method === 'GET' && url.searchParams.get('section_id') === 'api-cart-items') {
      url.searchParams.set('_btl', Date.now());
      return enqueue(() => originalFetch(url.href, {...init, cache:'no-store'}));
    }
    if (url.origin !== location.origin || method !== 'POST' || !/\/cart\/(add|change|update)(?:\.js)?$/.test(url.pathname)) return originalFetch(input, init);
    return enqueue(async () => {
      const response = await originalFetch(input, init);
      if (!response.ok) return response;
      try {
        const result = await synchronise();
        if (result.changed) {
          const data = await response.clone().json();
          if (data.sections) {
            const sectionsURL = new URL(location.href);
            sectionsURL.searchParams.delete('section_id');
            sectionsURL.searchParams.set('sections', Object.keys(data.sections).join(','));
            const sectionsResponse = await originalFetch(sectionsURL.href, {cache:'no-store'});
            if (!sectionsResponse.ok) throw new Error('Cart refresh failed.');
            data.sections = await sectionsResponse.json();
            return new Response(JSON.stringify(data), {status:response.status, headers:{'Content-Type':'application/json'}});
          }
        }
      } catch (error) {
        // The item was added successfully. Avoid duplicate additions on retry;
        // checkout performs a mandatory fresh check before continuing.
        console.warn('BTL delivery refresh:', error.message);
      }
      return response;
    });
  };
  const checkoutSelector = 'button[name="checkout"],input[name="checkout"],a[href*="/checkout"]';
  async function guardedCheckout(event, control, form) {
    if (resuming) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkingOut) return;
    checkingOut = true;
    try {
      await enqueue(synchronise);
      document.getElementById('btl-delivery-check-error')?.remove();
      resuming = true;
      if (control) control.click();
      else form.requestSubmit();
    } catch (error) { showError(); }
    finally { resuming = false; checkingOut = false; }
  }
  window.addEventListener('click', event => {
    const control = event.composedPath().find(node => node.matches?.(checkoutSelector) || (event.target.closest?.('checkout-plus') && node.matches?.('button#primary-button,button#secondary-button')));
    if (control) guardedCheckout(event, control, null);
  }, true);
  window.addEventListener('submit', event => {
    const form = event.target;
    if (form.matches?.('[data-cart-form]') && event.submitter?.name === 'checkout') guardedCheckout(event, event.submitter, form);
  }, true);
  async function refreshOpenPage() {
    if (checkingOut) return;
    try {
      const {changed} = await enqueue(synchronise);
      if (changed) refreshCart();
      if (location.pathname.includes('/products/')) {
        const state = await readState(location.pathname);
        const button = document.querySelector('product-info [data-add-to-cart][data-preorder]');
        const form = button?.form;
        const variant = state.product?.variants.find(v => String(v.id) === form?.elements.id?.value);
        if (variant && button.dataset.preorder !== String(variant.active)) location.reload();
      }
    } catch (error) { console.warn('BTL delivery refresh:', error.message); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshOpenPage, {once:true});
  else refreshOpenPage();
  window.addEventListener('pageshow', event => { if (event.persisted) refreshOpenPage(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshOpenPage(); });
})();
